import Vue from "vue";
import States from "@/enums/states";

export interface StateMixin {
  states: typeof States;
  state: States;
  currentStateIs: (state: States) => boolean;
  setState: (state: States) => void;
}

var stateMixin = Vue.extend({
  data() {
    return {
      states: States,
      state: States.INITIAL
    };
  },
  methods: {
    currentStateIs(state: States): boolean {
      return this.state === state;
    },
    setState(state: States): void {
      this.state = state;
    }
  }
});

export default stateMixin;
